import { render, staticRenderFns } from "./AffiliatesSolutions.vue?vue&type=template&id=09c71b4f&scoped=true"
import script from "./AffiliatesSolutions.js?vue&type=script&lang=js&external"
export * from "./AffiliatesSolutions.js?vue&type=script&lang=js&external"
import style0 from "./AffiliatesSolutions.scss?vue&type=style&index=0&id=09c71b4f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c71b4f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
